export enum SortType {
    AZ = 'az', //Alphabetical sort criteria
    UD = 'ud' //DateUpdated sort criteria
}
